import { MapElementFactory } from "vue2-google-maps";
import api from '@/helpers/api-rest/api.js';

export default MapElementFactory({
  name: "directionsRenderer",

  ctr() {
    return window.google.maps.DirectionsRenderer;
  },

  events: [],

  mappedProps: {},

  props: {
    origin: { type: Object },
    destination: { type: Object },
    travelMode: { type: String },
    routes: { type: Array },
    selectedRoute: { type: Object }
  },

  data() {
    return {
      tooltips: [], // Almacenar los tooltips creados
    };
  },
  methods: {
    async loadDataCalculate(distance, duration){
      const apiEndpoint = `/api/v1/calcular`;
      try {
        return await api.get({url:apiEndpoint, params: {
          distance: distance,
          duration: duration
        }});
      } catch (error) {
        console.error("Error loading data:", error);
      }
    }
  },

  afterCreate(directionsRenderer) {
    let directionsService = new window.google.maps.DirectionsService();
    this.directions = [];

    this.$watch(
      () => [this.origin, this.destination, this.travelMode, this.selectedRoute],
      () => {
        let { origin, destination, travelMode, selectedRoute } = this;

        // Cerrar y eliminar los tooltips anteriores
        this.tooltips.forEach((tooltip) => {
          tooltip.close();
          tooltip.setMap(null); // Elimina el tooltip del mapa
        });
        this.tooltips = [];

         // Borra todas las rutas anteriores
        this.directions.forEach((direction) => {
          direction.setMap(null); // Elimina la ruta del mapa
        });
        this.directions = [];

        if (!origin || !destination || !travelMode) return;

        directionsService.route(
          {
            origin,
            destination,
            travelMode,
            provideRouteAlternatives: true
          },
          (response, status) => {

            if (status !== "OK") return;

            const newRoutes = [];

            response.routes.forEach(async (route, index) => {
              // Crea un DirectionsRenderer para cada ruta y configura el mapa
              const renderer = new window.google.maps.DirectionsRenderer();
              renderer.setMap(directionsRenderer.getMap());

              let strokeOpacity = 0.5;
              //Oculta la ruta si no es la ruta seleccionada
              if (selectedRoute && route.summary !== selectedRoute.summary) {
                strokeOpacity = 0;
              }
              
              const infoRoute = response;
              infoRoute.routes = [route];
              if(index!== 0){
                renderer.setOptions({ 
                  polylineOptions: { strokeColor: "#888888", strokeOpacity:strokeOpacity },
                  suppressMarkers: true
                });
              }else{
                renderer.setOptions({ 
                  polylineOptions: { 
                    strokeOpacity:strokeOpacity
                  },
                  suppressMarkers: true 
                });
              }
              renderer.setDirections(infoRoute);

              // Calcula el punto medio de la polilínea de la ruta
              const path = route.overview_path;
              const midPointIndex = Math.floor(path.length / 2);
              const midPoint = path[midPointIndex];

              // Muestra la duración de la ruta en un tooltip en el punto medio de la ruta
              const duration = route.legs[0].duration.text;
              const distance = route.legs[0].distance.text;

              const responseCalculate = await this.loadDataCalculate(distance, duration);
              //Añadir duracion modificada a la duracion de la ruta
              route.legs[0].duration.text = responseCalculate.data.incremento_duracion;
              //Añadir el coste KG a la ruta
              route.legs[0].coste_kg = responseCalculate.data.coste_kg;

              const summary = route.summary;
              const contentString = 
              `<div class="content">`+
                `<div style="display:flex">`+
                  `<i class="fas fa-truck"></i>`+
                  `<p style="color: green; margin: -2px 0px 02px 10px;  font-weight: 900; font-family: Inter; font-size: 15px;"><b>${responseCalculate.data.incremento_duracion}</b></p>`+
                '</div>'+
                `<p style="font-weight:400; font-size: 12px; margin-bottom: 0rem !important; color: #BFC0C2; ">${distance} por ${summary}</p>`+
              `</div>`;
              const tooltip = new window.google.maps.InfoWindow({
                //content: `Duración: ${duration}`, //Muestra la duración de la ruta. se le puede pasar una variable
                content: contentString,
              });
              tooltip.setPosition(midPoint);
              tooltip.open(directionsRenderer.getMap());

              if (selectedRoute && route.summary !== selectedRoute.summary) {
                tooltip.close();
              }

              this.directions.push(renderer);
              this.tooltips.push(tooltip);

              console.log(route.legs[0]);

              newRoutes.push(route);
            });

            this.$emit("routes", newRoutes);

          }
        );
      }
    );
  }
});